(() => {
  class PromoListController {
    constructor(Promos) {
      'ngInject';

      Object.assign(this, {
        Promos,
        STATUSES: [{
          title: 'Pending',
          status: 'pending',
          selected: true
        }, {
          title: 'Active',
          status: 'active',
          selected: true
        }, {
          title: 'Expired',
          status: 'expired'
        }],
        pagination: {
          sort: 'name',
          order: 'asc'
        }
      });
      this.pagination.status = [this.STATUSES[0], this.STATUSES[1]];
      this.load();
    }

    onStatusChange() {
      this.pagination.offset = 0;
      this.load();
    }

    load() {
      this.loading = true;
      this.Promos.all(this.pagination).then(({
        data
      }) => {
        const {
          data: promos,
          pagination
        } = data;
        Object.assign(this.pagination, pagination);
        this.promos = promos.map(p => new Promo(p));
      }).finally(() => {
        this.loading = false;
      });
    }

  }

  PromoListController.$inject = ["Promos"];
  angular.module('pims').controller('PromoListController', PromoListController);
})();